import type { FormSchema, Schema } from '@cli-types/core-engine/schema.js'
import type { SchemaDiffField } from '@cli-types/core-engine/snapshots.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { getAllFormSchemaFields } from '@core-engine/schema/field-helpers/form-fields/get-all-form-schema-fields.js'

export function collectFields(schema: Schema | FormSchema): SchemaDiffField[] {
  if ('type' in schema && schema.type === 'form') {
    return getAllFormSchemaFields(schema as FormSchema)
      .filter((field): field is typeof field & { name: string } => Boolean(field.name))
      .map((field) => ({ name: field.name, type: field.type }))
  }

  return flattenFields(schema.fields).map((field) => ({
    name: field.name,
    type: field.type
  }))
}
